import EventBus from "./event-bus";
import * as _ from 'lodash';
import { base_url, EVENTS } from './constants';
import DataStore from './data-store';
import md5 from 'blueimp-md5';
import axios from 'axios';
import UrlService from "./url-service";
import ShopService from '../services/shop-service'
import UiService from '../services/ui-service'
import { Client } from "../../types";

let _identity: Client = undefined;
export default {
	get client() {
		return _identity;
	},
	fidCard: () => clientFidCardForShop(_identity, ShopService.shop),
	authorize,
	authenticate,
	logout,
	identity,
	getAddress,
	signupAsync,
	requestLoginAsync,
	clientFidCardForShop,
	getComoBalance,
}

init();
function init() {
	EventBus.$on(EVENTS.requestClientLogin, () => authorize(true));
}

function clientFidCardForShop(client: Client, shop: Shop) {
	let card = _.find(shop && client && client.fidelite_cards,(fidCard) => fidCard.GroupId == shop.GroupId);
	return card;
}

function requestLoginAsync() {
	return authorize()
	.then((isAuthenticated) => {
		if (isAuthenticated) {
			return Promise.resolve(_identity)
		} else {
			let promise = new Promise((resolve, reject) => {
				EventBus.$once(EVENTS.clientLogin, () => {
					resolve(_identity);
				});
			})
			return promise;
		}
	});
}

function authorize(force = false) {
	return identity(force)
	.then(client => {
		if (!client) {
			UiService.showClientLoginModal();
			return false;
		}
		return true;
	});
}

function authenticate(identity: Client) {
	if (_identity === identity) {
		return;
	}
	DataStore.normalizeClientData(identity)

	_identity = identity;
	EventBus.$emit(EVENTS.clientLogin, identity)

	promise = Promise.resolve(identity);

	if (identity) {
		var hash = md5(identity?.Email?.toLowerCase());
		axios.get("https://www.gravatar.com/avatar/" + hash + "?d=404")
		.then((res) => {
			if (res.status == 404) {
				identity.hasGravatar = false;
			} else {
				identity.hasGravatar = true;
			}
			DataStore.notifyAngularJs();
		})
	}
}

function logout() {
	return DataStore.post(base_url + '/admin/client/logout',{},'Echec lors de la déconnexion')
	.then(data => {
		authenticate(null);
		UrlService.go(null);
		return null
	})
}
// retourne une promise contenant les details du client
// var deferred = null;
let promise = null;
function identity(force = false) {
	if (force === true) {
		_identity = undefined;
		promise = undefined;
	}
	// someone has already checked
	if (promise) {
		return promise;
	}

	// otherwise, retrieve the identity data from the server, update the identity object, and then resolve.
	promise = new Promise((resolve, reject) => {
		DataStore.get(base_url + '/admin/client/identity','')
		.then(data => {
			authenticate(data.identity);
			resolve(data.identity);
		})
		.catch((err) => {
			authenticate(null)
			reject(err);
		});
	})

	return promise;
}

function getAddress(AddressId, client = _identity) {
	return _.find(client.addresses, {
		AddressId: AddressId
	})
}

function signupAsync(payload, mobileRequired = true) {
	if (!payload.Password || payload.Password.length < 6) {
		return Promise.reject({status: 'KO', msg: "Mot de passe minimum 6 caractères"});
	}
	if (mobileRequired && (!payload.Mobile || payload.Mobile.length < 7)) {
		return Promise.reject({status: 'KO', msg: "Mobile minimum 7 chiffres"});
	}
	return DataStore.post(base_url + '/admin/client/signup', payload,'')
	.then((data) => {
		var identity = data.identity
		authenticate(identity)
		return data;
	})
	.catch((err) => Promise.reject(err.data))
}

function getComoBalance(client: Client) {
	if (!client || !client.comoMembership) {
		return 0;
	}
	let balance = 0;
	if (client.comoMembership.creditBalance.usedByPayment) {
		balance = client.comoMembership.creditBalance.balance.monetary;
	}
	if (client.comoMembership.pointsBalance.usedByPayment) {
		balance = client.comoMembership.pointsBalance.balance.monetary;
	}
	balance = balance / 100.;
	return balance;
}